import { render } from "./fhqk.vue?vue&type=template&id=c792c216&scoped=true&ts=true"
import script from "./fhqk.vue?vue&type=script&lang=ts"
export * from "./fhqk.vue?vue&type=script&lang=ts"

import "./fhqk.vue?vue&type=style&index=0&id=c792c216&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c792c216"]])

export default __exports__